import { optionSchema } from "@/common/schemas/option.schema"
import { z } from "zod"

const producutsSchema = z.object({
  label: z.string().optional(),
  value: z.string().optional()
})

export const createSchema = z.object({
  display_name: z.string({ message: 'Campo obrigatório' }).min(3, { message: 'Tamanho minimo: 3 characteres' }).max(64, { message: 'Tamanho máximo: 64 characteres' }),
  year: z.string()
    .refine((value) => {
      return Number(value) > 1900
    }, {message: 'O ano deve ser superior a 1900'})
    .refine((value) => {
      return Number(value) <= (new Date()).getFullYear() + 1
    }, { message: 'O ano deve ser menor ou igual ao ano atual + 1' }),
  brand: z.string().min(3, { message: 'Tamanho minimo: 3 characteres' }).max(64, { message: 'Tamanho máximo: 64 characteres' }),
  category_id: z.object({
    label: z.string(),
    value: z.string()
  }, {message: 'Campo obrigatório'}),
  equipment_tier: optionSchema.optional().nullable(),
  applicable_product_ids: z.array(producutsSchema).optional()
})

export type EquipmentModelValidationSchema = z.infer<typeof createSchema>